const DEFAULT_WORKER_BASE = 'https://link-generator-worker.dispmail-linkhub.workers.dev';

const API_BASE = (process.env.REACT_APP_LINK_API_BASE || DEFAULT_WORKER_BASE).replace(/\/+$/, '');

const buildUrl = (path) => (API_BASE ? `${API_BASE}${path}` : path);

const parseError = async (response) => {
  try {
    const payload = await response.json();
    if (payload?.error) {
      return payload.error;
    }
  } catch {
    return `Request failed with status ${response.status}`;
  }
  return `Request failed with status ${response.status}`;
};

const getAuthHeaders = async (user) => {
  if (!user) {
    throw new Error('Please login to continue.');
  }

  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
};

export const generateCloudflareLink = async ({ user, appId, recipient, message, originalLink }) => {
  const headers = await getAuthHeaders(user);

  const response = await fetch(buildUrl('/api/links/generate'), {
    method: 'POST',
    headers,
    body: JSON.stringify({
      appId,
      recipient,
      message,
      originalLink
    })
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  return response.json();
};

export const generateGuestCloudflareLink = async ({ appId, recipient, message, originalLink }) => {
  const response = await fetch(buildUrl('/api/links/guest-generate'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      appId,
      recipient,
      message,
      originalLink
    })
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  return response.json();
};

export const listCloudflareLinks = async ({ user, appId = 'all' }) => {
  const headers = await getAuthHeaders(user);
  const query = new URLSearchParams({ appId });

  const response = await fetch(buildUrl(`/api/links?${query.toString()}`), {
    method: 'GET',
    headers
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  return response.json();
};

export const syncCloudflareUser = async ({ user }) => {
  const headers = await getAuthHeaders(user);

  const response = await fetch(buildUrl('/api/user/sync'), {
    method: 'POST',
    headers
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  return response.json();
};

export const getCloudflareLinkAnalytics = async ({ user, shortCode, range = '24h', start = '', end = '' }) => {
  const headers = await getAuthHeaders(user);
  const query = new URLSearchParams({ shortCode, range });
  if (start) {
    query.set('start', start);
  }
  if (end) {
    query.set('end', end);
  }

  const response = await fetch(buildUrl(`/api/links/analytics?${query.toString()}`), {
    method: 'GET',
    headers
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  return response.json();
};